import { useHistory, useParams } from "react-router-dom";
import Algolia from "../../Algolia/Algolia";
import ChatBox from "../../ChatBox/ChatBox";
import { useMediaQuery } from "../../CustomHooks/useMediaQuery";
import {
  Addsvg,
  ButtonDesc,
  Container,
  Content,
  Left,
  Modal,
  NewChatButton,
  Right,
  Title,
  Top,
} from "./ChatpageElements";
import styled from "styled-components";
import { db, messaging } from "../../../firebase";
import { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import VideoChatRoom from "../../VideoChat/VideoChatRoom";
import { deleteToken, getToken } from "firebase/messaging";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { context } from "../../../Globals/GlobalStateProvider";

const Styledsvg = styled.svg`
  width: clamp(90%, 500px, 60%);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: visible;
`;

const variants = {
  hidden: {
    y: "-100vh",
  },
  visible: {
    y: 0,
    transition: {
      duration: 1,
    },
  },
};
const Undraw = () => (
  <Styledsvg viewBox="0 0 65 54" fill="none">
    <path
      id="Bottom"
      d="M30.5306 54.0001C44.7081 54.0001 56.2011 53.4161 56.2011 52.6957C56.2011 51.9753 44.7081 51.3914 30.5306 51.3914C16.3532 51.3914 4.86011 51.9753 4.86011 52.6957C4.86011 53.4161 16.3532 54.0001 30.5306 54.0001Z"
      fill="#F2F2F2"
    />
    <motion.g
      variants={variants}
      animate="visible"
      initial="hidden"
      id="PhoneFrame"
    >
      <path
        id="Vector"
        d="M45.5285 12.5325H45.2369V4.59438C45.2369 3.37587 44.7497 2.20728 43.8826 1.34566C43.0155 0.484051 41.8394 1.34532e-06 40.6131 0H23.6876C22.4613 -2.30624e-06 21.2852 0.484043 20.4181 1.34565C19.551 2.20726 19.0638 3.37586 19.0638 4.59436V48.1436C19.0638 49.3621 19.551 50.5307 20.4181 51.3923C21.2852 52.2539 22.4613 52.7379 23.6876 52.7379H40.6131C41.8394 52.7379 43.0155 52.2539 43.8826 51.3923C44.7497 50.5307 45.2369 49.3621 45.2369 48.1436V18.183H45.5285L45.5285 12.5325Z"
        fill="#3F3D56"
      />
      <path
        id="Vector_2"
        d="M44.2527 4.6265V48.1116C44.2527 49.0216 43.8889 49.8943 43.2413 50.5378C42.5937 51.1813 41.7154 51.5428 40.7996 51.5428H23.7928C22.877 51.5428 21.9987 51.1813 21.3511 50.5378C20.7036 49.8943 20.3397 49.0216 20.3397 48.1116V4.6265C20.3397 3.7165 20.7036 2.84377 21.3511 2.2003C21.9987 1.55683 22.877 1.19533 23.7928 1.19531H25.856C25.7546 1.44285 25.716 1.71135 25.7435 1.97719C25.7711 2.24303 25.864 2.49807 26.014 2.71987C26.1641 2.94167 26.3667 3.12343 26.604 3.24918C26.8413 3.37492 27.1061 3.44078 27.375 3.44098H37.0715C37.3405 3.44078 37.6052 3.37491 37.8426 3.24917C38.0799 3.12343 38.2825 2.94166 38.4325 2.71986C38.5826 2.49806 38.6754 2.24302 38.703 1.97718C38.7306 1.71134 38.692 1.44285 38.5906 1.19531H40.7996C41.7154 1.19533 42.5937 1.55683 43.2413 2.2003C43.8889 2.84377 44.2527 3.7165 44.2527 4.6265V4.6265Z"
        fill="white"
      />
    </motion.g>
    <motion.g
      id="TopPerson"
      animate={{ y: 0 }}
      initial={{ y: "-100vh" }}
      transition={{ delay: 0.2, duration: 1, type: "spring" }}
    >
      <path
        id="Vector_3"
        d="M38.774 23.377C38.6609 23.4357 38.5459 23.4913 38.429 23.5437C38.3225 23.5915 38.2144 23.6364 38.1045 23.6785C38.0644 23.6937 38.0236 23.7089 37.9827 23.7241C37.6598 23.8405 37.3282 23.9314 36.9909 23.9959C36.8239 24.0285 36.6547 24.0541 36.4833 24.0727C36.3418 24.0886 36.1989 24.1 36.0545 24.1067C35.9517 24.1118 35.8488 24.114 35.7453 24.114C35.3352 24.1142 34.926 24.0761 34.523 24.0002C34.418 23.9814 34.3152 23.9589 34.2123 23.9343C33.715 23.8158 33.2334 23.6392 32.7779 23.4082C32.737 23.3879 32.6962 23.3662 32.6553 23.3451C32.5948 23.3133 32.5358 23.2799 32.4767 23.2451C32.5051 23.206 32.5358 23.1676 32.5671 23.1299C32.9083 22.7097 33.3349 22.3657 33.8189 22.1202C34.3029 21.8748 34.8336 21.7334 35.3762 21.7054C35.9189 21.6773 36.4615 21.7633 36.9685 21.9575C37.4755 22.1518 37.9356 22.45 38.3189 22.8328C38.4519 22.9655 38.5752 23.1074 38.6879 23.2575C38.7178 23.2966 38.7463 23.3364 38.774 23.377Z"
        fill="#2A8BF2"
      />
      <path
        id="Vector_4"
        d="M35.8908 20.1939C37.6594 20.1939 39.093 18.7693 39.093 17.012C39.093 15.2547 37.6594 13.8301 35.8908 13.8301C34.1223 13.8301 32.6886 15.2547 32.6886 17.012C32.6886 18.7693 34.1223 20.1939 35.8908 20.1939Z"
        fill="#2F2E41"
      />
      <path
        id="Vector_5"
        d="M36.7425 20.1983C37.8975 19.5709 38.322 18.132 37.6906 16.9844C37.0592 15.8367 35.6111 15.4149 34.4561 16.0423C33.3012 16.6697 32.8767 18.1086 33.5081 19.2562C34.1394 20.4038 35.5875 20.8256 36.7425 20.1983Z"
        fill="#A0616A"
      />
      <path
        id="Vector_6"
        d="M38.1037 16.6307C37.5591 17.0037 36.9126 17.2022 36.2512 17.1996C36.4871 17.3621 36.7558 17.4719 37.0385 17.5214C36.1591 17.7089 35.2502 17.714 34.3686 17.5363C34.1727 17.5051 33.9836 17.4406 33.8097 17.3456C33.7231 17.2975 33.6476 17.2318 33.5881 17.1528C33.5287 17.0739 33.4866 16.9833 33.4647 16.8871C33.4062 16.5546 33.6669 16.2525 33.9379 16.0489C34.3528 15.742 34.8311 15.5305 35.3384 15.4298C35.8456 15.3291 36.369 15.3416 36.8708 15.4666C37.1984 15.5507 37.5266 15.6929 37.7394 15.9544C37.9522 16.2158 38.0153 16.6188 37.8125 16.888L38.1037 16.6307Z"
        fill="#2F2E41"
      />
      <path
        id="Vector_7"
        d="M35.7452 11.0706C34.3138 11.0703 32.9216 11.5352 31.7808 12.3942C30.6399 13.2532 29.813 14.4594 29.4261 15.8287C29.0391 17.1981 29.1134 18.6556 29.6376 19.9792C30.1617 21.3027 31.107 22.4196 32.3293 23.1598L32.3716 23.1844C32.4066 23.2054 32.4416 23.2257 32.4766 23.2453C32.5357 23.2801 32.5948 23.3134 32.6553 23.3453C32.6961 23.3663 32.737 23.388 32.7778 23.4083C33.2334 23.6394 33.7149 23.816 34.2123 23.9344C34.3151 23.9591 34.418 23.9815 34.523 24.0004C34.9259 24.0762 35.3351 24.1143 35.7452 24.1141C35.8488 24.1141 35.9516 24.112 36.0545 24.1069C36.1989 24.1004 36.3418 24.089 36.4833 24.0728C36.6547 24.054 36.8239 24.0284 36.9909 23.996C37.3281 23.9315 37.6598 23.8406 37.9827 23.7243C38.0235 23.7091 38.0643 23.6938 38.1045 23.6786C38.2146 23.6366 38.3227 23.5917 38.429 23.5438C38.5457 23.4917 38.6607 23.4361 38.774 23.3772C39.9092 22.7864 40.8476 21.8809 41.4752 20.7706C41.4781 20.7648 41.4817 20.759 41.4847 20.7532C41.8195 20.1562 42.057 19.5103 42.1884 18.8395C42.3729 17.8951 42.3449 16.9218 42.1066 15.9894C41.8682 15.057 41.4253 14.1885 40.8096 13.4461C40.1939 12.7037 39.4205 12.1057 38.545 11.695C37.6695 11.2843 36.7134 11.0711 35.7453 11.0706H35.7452ZM41.3651 20.6685C41.3592 20.6786 41.3541 20.6887 41.3483 20.6982C40.7332 21.7921 39.8081 22.6821 38.6879 23.2576C38.5763 23.3156 38.4628 23.3699 38.3473 23.4207C38.2518 23.4634 38.1541 23.504 38.0556 23.5417C38.014 23.5576 37.9717 23.5736 37.9294 23.588C37.6505 23.6893 37.3646 23.7707 37.074 23.8315C36.8584 23.8771 36.6405 23.9112 36.4213 23.9337C36.2864 23.9482 36.1493 23.9583 36.0114 23.9634C35.9232 23.967 35.8342 23.9692 35.7452 23.9692C35.3484 23.9697 34.9523 23.933 34.5624 23.8598C34.3251 23.8163 34.0906 23.7592 33.8601 23.6888C33.5088 23.5809 33.1675 23.4435 32.8398 23.2779C32.8019 23.2583 32.764 23.2388 32.7268 23.2185C32.6735 23.1902 32.6196 23.1612 32.5671 23.1301C32.5277 23.1083 32.4883 23.0851 32.4496 23.062C32.427 23.0489 32.4044 23.0351 32.3818 23.0214C31.3101 22.3674 30.4552 21.4152 29.9232 20.2828C29.3912 19.1505 29.2054 17.8879 29.389 16.6516C29.5726 15.4153 30.1175 14.2598 30.9559 13.3284C31.7944 12.397 32.8897 11.7307 34.1058 11.4121C35.3219 11.0936 36.6054 11.1369 37.797 11.5365C38.9886 11.9362 40.0359 12.6747 40.8089 13.6604C41.582 14.6462 42.0467 15.8357 42.1456 17.0815C42.2445 18.3273 41.9731 19.5745 41.365 20.6685H41.3651Z"
        fill="#3F3D56"
      />
      <path
        id="Vector_8"
        d="M34.2692 13.874C34.2348 13.5139 33.7909 13.2923 33.4438 13.4011C33.0967 13.5098 32.8689 13.8571 32.8 14.2122C32.7668 14.3617 32.7637 14.5163 32.7908 14.667C32.8179 14.8178 32.8747 14.9617 32.9579 15.0906C33.1333 15.3415 33.4558 15.4981 33.7565 15.4344C34.0997 15.3617 34.3376 15.0286 34.4056 14.6865C34.4737 14.3443 34.4061 13.9916 34.3386 13.6493L34.2692 13.874Z"
        fill="#2F2E41"
      />
      <path
        id="Vector_9"
        d="M39.1541 14.3884C39.1197 14.0284 38.6758 13.8067 38.3287 13.9155C37.9816 14.0242 37.7538 14.3715 37.6849 14.7266C37.6517 14.8761 37.6486 15.0307 37.6757 15.1814C37.7028 15.3322 37.7596 15.4761 37.8428 15.605C38.0182 15.8559 38.3406 16.0125 38.6413 15.9488C38.9846 15.8761 39.2224 15.543 39.2905 15.2009C39.3585 14.8587 39.291 14.506 39.2235 14.1637L39.1541 14.3884Z"
        fill="#2F2E41"
      />
    </motion.g>
    <motion.g
      id="TopChat"
      animate={{ y: 0 }}
      initial={{ y: "-100vh" }}
      transition={{ delay: 0.4, duration: 1, type: "spring" }}
    >
      <path
        id="Vector_10"
        d="M24.4777 20.8971C25.4646 20.8971 26.2647 20.8088 26.2647 20.7C26.2647 20.5912 25.4646 20.5029 24.4777 20.5029C23.4907 20.5029 22.6907 20.5912 22.6907 20.7C22.6907 20.8088 23.4907 20.8971 24.4777 20.8971Z"
        fill="#F2F2F2"
      />
      <path
        id="Vector_11"
        d="M24.4004 20.1986C24.355 20.1986 24.3101 20.1891 24.2686 20.1708C24.227 20.1526 24.1898 20.1259 24.1593 20.0925L20.5404 16.1698C20.4994 16.1253 20.4495 16.0899 20.3939 16.0656C20.3384 16.0413 20.2783 16.0287 20.2176 16.0287H1.09459C0.804387 16.0283 0.526163 15.9136 0.320958 15.7097C0.115753 15.5058 0.000325825 15.2294 0 14.941V8.08861C0.000325632 7.80025 0.115753 7.5238 0.320958 7.3199C0.526163 7.11599 0.804387 7.0013 1.09459 7.00098H25.8699C26.1601 7.0013 26.4384 7.11599 26.6436 7.3199C26.8488 7.5238 26.9642 7.80025 26.9645 8.08861V14.941C26.9642 15.2294 26.8488 15.5058 26.6436 15.7097C26.4384 15.9136 26.1601 16.0283 25.8699 16.0287H25.1675C25.0514 16.0288 24.9401 16.0747 24.858 16.1563C24.7759 16.2378 24.7298 16.3484 24.7296 16.4638V19.872C24.7299 19.9378 24.7101 20.0021 24.6727 20.0565C24.6353 20.1108 24.5821 20.1525 24.5203 20.1761C24.4821 20.1909 24.4414 20.1986 24.4004 20.1986V20.1986Z"
        fill="white"
      />
      <path
        id="Vector_12"
        d="M24.4004 20.1986C24.355 20.1986 24.3101 20.1891 24.2686 20.1708C24.227 20.1526 24.1898 20.1259 24.1593 20.0925L20.5404 16.1698C20.4994 16.1253 20.4495 16.0899 20.3939 16.0656C20.3384 16.0413 20.2783 16.0287 20.2176 16.0287H1.09459C0.804387 16.0283 0.526163 15.9136 0.320958 15.7097C0.115753 15.5058 0.000325825 15.2294 0 14.941V8.08861C0.000325632 7.80025 0.115753 7.5238 0.320958 7.3199C0.526163 7.11599 0.804387 7.0013 1.09459 7.00098H25.8699C26.1601 7.0013 26.4384 7.11599 26.6436 7.3199C26.8488 7.5238 26.9642 7.80025 26.9645 8.08861V14.941C26.9642 15.2294 26.8488 15.5058 26.6436 15.7097C26.4384 15.9136 26.1601 16.0283 25.8699 16.0287H25.1675C25.0514 16.0288 24.9401 16.0747 24.858 16.1563C24.7759 16.2378 24.7298 16.3484 24.7296 16.4638V19.872C24.7299 19.9378 24.7101 20.0021 24.6727 20.0565C24.6353 20.1108 24.5821 20.1525 24.5203 20.1761C24.4821 20.1909 24.4414 20.1986 24.4004 20.1986V20.1986ZM1.09459 7.14591C0.843057 7.14619 0.601907 7.2456 0.424046 7.42233C0.246185 7.59906 0.146139 7.83868 0.145855 8.08861V14.941C0.14614 15.191 0.246187 15.4306 0.424047 15.6073C0.601908 15.784 0.843058 15.8834 1.09459 15.8837H20.2176C20.2986 15.8838 20.3786 15.9006 20.4526 15.933C20.5267 15.9653 20.5932 16.0126 20.6479 16.0718L24.2668 19.9946C24.2916 20.0215 24.3241 20.0403 24.3599 20.0486C24.3957 20.0569 24.4332 20.0543 24.4674 20.041C24.5017 20.0278 24.5312 20.0046 24.5519 19.9744C24.5727 19.9442 24.5838 19.9086 24.5838 19.872V16.4638C24.584 16.31 24.6455 16.1626 24.755 16.0538C24.8644 15.9451 25.0128 15.8839 25.1675 15.8837H25.8699C26.1215 15.8834 26.3626 15.784 26.5405 15.6073C26.7183 15.4306 26.8184 15.191 26.8187 14.941V8.08861C26.8184 7.83868 26.7183 7.59906 26.5405 7.42233C26.3626 7.2456 26.1215 7.14619 25.8699 7.14591H1.09459Z"
        fill="#3F3D56"
      />
      <path
        id="Vector_13"
        d="M2.68498 10.0238C3.21397 10.0238 3.64279 9.59771 3.64279 9.07209C3.64279 8.54646 3.21397 8.12036 2.68498 8.12036C2.156 8.12036 1.72717 8.54646 1.72717 9.07209C1.72717 9.59771 2.156 10.0238 2.68498 10.0238Z"
        fill="#2A8BF2"
      />
      <path
        id="Vector_14"
        d="M24.7525 14.3384H2.212C2.14487 14.3385 2.07838 14.3254 2.01633 14.2999C1.95428 14.2745 1.8979 14.2371 1.8504 14.19C1.8029 14.1428 1.76521 14.0868 1.7395 14.0252C1.71379 13.9636 1.70056 13.8975 1.70056 13.8308C1.70056 13.7641 1.71379 13.6981 1.7395 13.6364C1.76521 13.5748 1.8029 13.5188 1.8504 13.4717C1.8979 13.4246 1.95428 13.3872 2.01633 13.3617C2.07838 13.3362 2.14487 13.3232 2.212 13.3232H24.7525C24.8878 13.3234 25.0176 13.377 25.1133 13.4721C25.2089 13.5673 25.2627 13.6963 25.2627 13.8308C25.2627 13.9653 25.2089 14.0944 25.1133 14.1895C25.0176 14.2847 24.8878 14.3383 24.7525 14.3384V14.3384Z"
        fill="#E6E6E6"
      />
      <path
        id="Vector_15"
        d="M17.4092 12.181H2.212C2.14487 12.181 2.07838 12.168 2.01633 12.1425C1.95428 12.117 1.8979 12.0796 1.8504 12.0325C1.8029 11.9854 1.76521 11.9294 1.7395 11.8677C1.71379 11.8061 1.70056 11.7401 1.70056 11.6734C1.70056 11.6067 1.71379 11.5406 1.7395 11.479C1.76521 11.4174 1.8029 11.3614 1.8504 11.3142C1.8979 11.2671 1.95428 11.2297 2.01633 11.2042C2.07838 11.1788 2.14487 11.1657 2.212 11.1658H17.4092C17.5447 11.1658 17.6747 11.2193 17.7705 11.3144C17.8663 11.4096 17.9201 11.5387 17.9201 11.6734C17.9201 11.808 17.8663 11.9371 17.7705 12.0323C17.6747 12.1275 17.5447 12.181 17.4092 12.181Z"
        fill="#E6E6E6"
      />
    </motion.g>
    <motion.g
      id="BottomPerson"
      animate={{ y: 0 }}
      initial={{ y: "-100vh" }}
      transition={{ delay: 0.5, duration: 1, type: "spring" }}
    >
      <path
        id="Vector_16"
        d="M32.7574 45.5592C31.7414 46.2056 30.5643 46.5581 29.358 46.5772C28.1517 46.5963 26.9639 46.2811 25.9277 45.6671C26.11 45.33 26.341 45.0211 26.6133 44.7505C27.0334 44.331 27.5448 44.0128 28.108 43.8203C28.6712 43.6279 29.2713 43.5663 29.8622 43.6402C30.4532 43.7142 31.0192 43.9218 31.5168 44.247C32.0143 44.5722 32.4303 45.0065 32.7326 45.5164C32.7406 45.5302 32.7494 45.5447 32.7574 45.5592Z"
        fill="#2A8BF2"
      />
      <path
        id="Vector_17"
        d="M29.0575 42.0938C30.8378 42.0938 32.281 40.6598 32.281 38.8908C32.281 37.1218 30.8378 35.6877 29.0575 35.6877C27.2772 35.6877 25.834 37.1218 25.834 38.8908C25.834 40.6598 27.2772 42.0938 29.0575 42.0938Z"
        fill="#2F2E41"
      />
      <path
        id="Vector_18"
        d="M31.4561 41.15C32.0917 39.9947 31.6644 38.5462 30.5017 37.9147C29.3391 37.2832 27.8813 37.7078 27.2458 38.863C26.6102 40.0183 27.0375 41.4668 28.2001 42.0983C29.3628 42.7298 30.8205 42.3053 31.4561 41.15Z"
        fill="#FFB8B8"
      />
      <path
        id="Vector_19"
        d="M26.8298 38.5071C27.3781 38.8825 28.0288 39.0824 28.6947 39.0797C28.4571 39.2434 28.1867 39.3539 27.9021 39.4037C28.7874 39.5924 29.7024 39.5975 30.5897 39.4187C30.787 39.3873 30.9773 39.3223 31.1524 39.2267C31.2396 39.1783 31.3156 39.1122 31.3754 39.0327C31.4353 38.9532 31.4776 38.862 31.4996 38.7652C31.5586 38.4305 31.2961 38.1264 31.0233 37.9214C30.6057 37.6124 30.1241 37.3995 29.6135 37.2981C29.1029 37.1968 28.576 37.2094 28.0709 37.3352C27.7411 37.4199 27.4108 37.563 27.1965 37.8262C26.9823 38.0894 26.9189 38.4951 27.123 38.7661L26.8298 38.5071Z"
        fill="#2F2E41"
      />
      <path
        id="Vector_20"
        d="M29.2547 46.6504C27.676 46.6499 26.1504 46.0838 24.9578 45.056C23.7651 44.0283 22.9854 42.6077 22.7616 41.0548C22.5378 39.502 22.885 37.9211 23.7394 36.602C24.5938 35.2829 25.8982 34.3142 27.4133 33.8734C28.9284 33.4327 30.5527 33.5496 31.9881 34.2026C33.4235 34.8556 34.5739 36.0009 35.2282 37.4285C35.8825 38.8561 35.9968 40.4703 35.5502 41.9749C35.1037 43.4795 34.1261 44.7737 32.7969 45.62C31.7399 46.2935 30.5104 46.6511 29.2547 46.6504V46.6504ZM29.2547 33.7517C27.9853 33.7516 26.7443 34.1255 25.6887 34.8263C24.6332 35.527 23.8104 36.523 23.3246 37.6884C22.8387 38.8537 22.7116 40.1361 22.9592 41.3732C23.2068 42.6104 23.8181 43.7468 24.7158 44.6387C25.6134 45.5307 26.7571 46.1381 28.0021 46.3841C29.2472 46.6302 30.5378 46.5038 31.7106 46.0211C32.8834 45.5383 33.8858 44.7208 34.591 43.6719C35.2962 42.6231 35.6725 41.39 35.6724 40.1286C35.6704 38.4379 34.9937 36.8171 33.7906 35.6216C32.5874 34.4261 30.9562 33.7536 29.2547 33.7517V33.7517Z"
        fill="#3F3D56"
      />
    </motion.g>
    <motion.g
      id="BottomChat"
      animate={{ y: 0 }}
      initial={{ y: "-100vh" }}
      transition={{ delay: 0.7, duration: 1, type: "spring" }}
    >
      <path
        id="Vector_21"
        d="M40.4797 43.4371C40.4179 43.4135 40.3648 43.3718 40.3274 43.3174C40.29 43.2631 40.2701 43.1988 40.2704 43.133V39.7248C40.2703 39.6094 40.2241 39.4988 40.142 39.4172C40.0599 39.3357 39.9486 39.2898 39.8325 39.2896H39.1301C38.8399 39.2893 38.5617 39.1746 38.3565 38.9707C38.1513 38.7668 38.0358 38.4904 38.0355 38.202V31.3496C38.0358 31.0612 38.1513 30.7848 38.3565 30.5809C38.5617 30.377 38.8399 30.2623 39.1301 30.262H63.9055C64.1957 30.2623 64.4739 30.377 64.6791 30.5809C64.8843 30.7848 64.9997 31.0612 65 31.3496V38.202C64.9997 38.4904 64.8843 38.7668 64.6791 38.9707C64.4739 39.1746 64.1957 39.2893 63.9055 39.2896H44.7824C44.7217 39.2897 44.6617 39.3023 44.6061 39.3266C44.5506 39.3509 44.5007 39.3863 44.4596 39.4307L40.8408 43.3535C40.8102 43.3869 40.773 43.4135 40.7315 43.4318C40.69 43.4501 40.6451 43.4596 40.5996 43.4596C40.5586 43.4596 40.5179 43.4519 40.4797 43.4371V43.4371Z"
        fill="white"
      />
      <path
        id="Vector_22"
        d="M40.4797 43.4371C40.4179 43.4135 40.3648 43.3718 40.3274 43.3174C40.29 43.2631 40.2701 43.1988 40.2704 43.133V39.7248C40.2703 39.6094 40.2241 39.4988 40.142 39.4172C40.0599 39.3357 39.9486 39.2898 39.8325 39.2896H39.1301C38.8399 39.2893 38.5617 39.1746 38.3565 38.9707C38.1513 38.7668 38.0358 38.4904 38.0355 38.202V31.3496C38.0358 31.0612 38.1513 30.7848 38.3565 30.5809C38.5617 30.377 38.8399 30.2623 39.1301 30.262H63.9055C64.1957 30.2623 64.4739 30.377 64.6791 30.5809C64.8843 30.7848 64.9997 31.0612 65 31.3496V38.202C64.9997 38.4904 64.8843 38.7668 64.6791 38.9707C64.4739 39.1746 64.1957 39.2893 63.9055 39.2896H44.7824C44.7217 39.2897 44.6617 39.3023 44.6061 39.3266C44.5506 39.3509 44.5007 39.3863 44.4596 39.4307L40.8408 43.3535C40.8102 43.3869 40.773 43.4135 40.7315 43.4318C40.69 43.4501 40.6451 43.4596 40.5996 43.4596C40.5586 43.4596 40.5179 43.4519 40.4797 43.4371V43.4371ZM39.1301 30.4069C38.8786 30.4072 38.6374 30.5066 38.4596 30.6833C38.2817 30.86 38.1817 31.0997 38.1814 31.3496V38.202C38.1817 38.4519 38.2817 38.6916 38.4596 38.8683C38.6374 39.045 38.8786 39.1444 39.1301 39.1447H39.8325C39.9873 39.1449 40.1357 39.2061 40.2451 39.3148C40.3545 39.4236 40.4161 39.571 40.4163 39.7248V43.133C40.4163 43.1695 40.4274 43.2052 40.4481 43.2354C40.4689 43.2655 40.4983 43.2888 40.5326 43.302C40.5669 43.3152 40.6044 43.3179 40.6402 43.3096C40.676 43.3013 40.7084 43.2825 40.7333 43.2555L44.3521 39.3328C44.4068 39.2736 44.4734 39.2263 44.5474 39.1939C44.6215 39.1616 44.7015 39.1448 44.7824 39.1447H63.9055C64.157 39.1444 64.3981 39.045 64.576 38.8683C64.7539 38.6916 64.8539 38.4519 64.8542 38.202V31.3496C64.8539 31.0997 64.7539 30.86 64.576 30.6833C64.3981 30.5066 64.157 30.4072 63.9055 30.4069H39.1301Z"
        fill="#3F3D56"
      />
      <path
        id="Vector_23"
        d="M41.1177 33.2123C41.6467 33.2123 42.0755 32.7862 42.0755 32.2606C42.0755 31.7349 41.6467 31.3088 41.1177 31.3088C40.5887 31.3088 40.1599 31.7349 40.1599 32.2606C40.1599 32.7862 40.5887 33.2123 41.1177 33.2123Z"
        fill="#2A8BF2"
      />
      <path
        id="Vector_24"
        d="M63.1853 37.5267H40.6449C40.5777 37.5267 40.5112 37.5137 40.4492 37.4882C40.3871 37.4627 40.3308 37.4254 40.2833 37.3782C40.2358 37.3311 40.1981 37.2751 40.1724 37.2135C40.1467 37.1518 40.1334 37.0858 40.1334 37.0191C40.1334 36.9524 40.1467 36.8863 40.1724 36.8247C40.1981 36.7631 40.2358 36.7071 40.2833 36.6599C40.3308 36.6128 40.3871 36.5754 40.4492 36.5499C40.5112 36.5245 40.5777 36.5114 40.6449 36.5115H63.1853C63.3208 36.5115 63.4507 36.565 63.5465 36.6601C63.6423 36.7553 63.6962 36.8844 63.6962 37.0191C63.6962 37.1537 63.6423 37.2828 63.5465 37.378C63.4507 37.4732 63.3208 37.5267 63.1853 37.5267Z"
        fill="#E6E6E6"
      />
      <path
        id="Vector_25"
        d="M55.8421 35.3697H40.6449C40.5777 35.3698 40.5112 35.3567 40.4492 35.3312C40.3871 35.3057 40.3308 35.2684 40.2833 35.2212C40.2358 35.1741 40.1981 35.1181 40.1724 35.0565C40.1467 34.9948 40.1334 34.9288 40.1334 34.8621C40.1334 34.7954 40.1467 34.7293 40.1724 34.6677C40.1981 34.6061 40.2358 34.5501 40.2833 34.5029C40.3308 34.4558 40.3871 34.4184 40.4492 34.393C40.5112 34.3675 40.5777 34.3544 40.6449 34.3545H55.8421C55.9775 34.3547 56.1072 34.4082 56.2029 34.5034C56.2986 34.5986 56.3523 34.7276 56.3523 34.8621C56.3523 34.9966 56.2986 35.1256 56.2029 35.2208C56.1072 35.316 55.9775 35.3695 55.8421 35.3697V35.3697Z"
        fill="#E6E6E6"
      />
      <path
        id="Vector_26"
        d="M40.4488 44.0858C41.4357 44.0858 42.2358 43.9976 42.2358 43.8887C42.2358 43.7799 41.4357 43.6917 40.4488 43.6917C39.4618 43.6917 38.6617 43.7799 38.6617 43.8887C38.6617 43.9976 39.4618 44.0858 40.4488 44.0858Z"
        fill="#F2F2F2"
      />
    </motion.g>
    <defs>
      <clipPath id="clip0_113:636">
        <rect width="65" height="54" fill="white" />
      </clipPath>
    </defs>
  </Styledsvg>
);

const Back = styled(motion.button)`
  position: absolute;
  top: 0px;
  right: 0;
  padding: 10px;
  width: 70px;
  height: 80px;
  border-radius: 0 0 0 70px;
  border: none;
  background: linear-gradient(325.78deg, #2a8bf2 14.76%, #7cb8f7 87.3%);
  cursor: pointer;
`;

const Svg = styled.svg`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
`;
const Chatpage = ({ StartVideocall }: { StartVideocall: () => void }) => {
  const history = useHistory();
  const { roomid }: { roomid: string } = useParams();
  const matches = useMediaQuery("(max-width: 600px)");
  const [modalOpen, setmodalOpen] = useState(false);
  const { globalstate } = useContext(context);
  const user = globalstate.user;
  //save token to database.

  const saveToken = async () => {
    await deleteToken(messaging);
    getToken(messaging, {
      vapidKey:
        "BLFRbbKh7i-skCjTBESy0m4xdv_644zN92do2g98YC0BUt-SBgYcj0hb2NFE584YDKAZChVS01AfgMsEpT6Xgs8",
    })
      .then(async (currentToken) => {
        if (currentToken) {
          console.log(currentToken, "watching");
          //Save the user's notification token to the database.

          if ((await getDoc(doc(db, "users", user.uid))).exists()) {
            const tokenref = await updateDoc(doc(db, `users/${user.uid}/`), {
              notificationToken: currentToken,
            });
          } else {
            await setDoc(doc(db, "users", user.uid), {
              notificationToken: currentToken,
            });
          }

          // ...
        } else {
          // Show permission request UI
          console.log(
            "No registration token available. Request permission to generate one."
          );
          // ...
        }
      })
      .catch(async (err) => {
        console.log("An error occurred while retrieving token. ", err);
        // create user doc
        if (!(await getDoc(doc(db, "users", user.uid))).exists()) {  
          await setDoc(doc(db, "users", user.uid), {});
        }
        // ...
      });
  };
  useEffect(() => {
    saveToken();
  }, []);

  const OpenModal = () => {
    setmodalOpen(true);
  };
  const CloseModal = () => {
    setmodalOpen(false);
  };
  const ChangeToRoomListView = () => {
    history.goBack();
    const slider = document.querySelector(".View__Slider") as HTMLElement;
    slider.style.transform = "translateX(0)";
  };

  return (
    <>
      {matches && roomid ? (
        <Back
          whileTap={{ scale: 0.9 }}
          whileHover={{ scale: 1.1 }}
          onClick={() => ChangeToRoomListView()}
        >
          <Svg width="12" height="20" viewBox="0 0 12 20" fill="none">
            <path
              d="M11.67 1.86998L9.9 0.0999756L0 9.99998L9.9 19.9L11.67 18.13L3.54 9.99998L11.67 1.86998Z"
              fill="white"
            />
          </Svg>
        </Back>
      ) : (
        ""
      )}
      {modalOpen && <Modal handleClose={CloseModal}></Modal>}

      <Container>
        <Content className="View__Slider">
          <Left>
            <Top>
              <Title>Chat</Title>
              <NewChatButton onClick={() => OpenModal()}>
                <Addsvg
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
                </Addsvg>
                <ButtonDesc>Create New Chat</ButtonDesc>
              </NewChatButton>
            </Top>
            <Algolia />
          </Left>
          <Right>
            {roomid ? (
              <ChatBox startvideocall={StartVideocall}></ChatBox>
            ) : (
              <Undraw></Undraw>
            )}
          </Right>
        </Content>
      </Container>
    </>
  );
};

export default Chatpage;
